export default __webpack_public_path__ + "static/media/side.6d124463.png";